import axios from "axios";

export default function escalateTicket({ ticketId, escalatedToAgentId, escalatedToAgentName, reason }) {
  return new Promise((resolve, reject) =>
    axios
      .post(`/support/api/v1/admin/tickets/${ticketId}/escalate`, {
        escalated_to_agent_id: escalatedToAgentId,
        escalated_to_agent_name: escalatedToAgentName,
        reason: reason || null,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
